module.exports = __webpack_public_path__ + "public/adminIcons/message.svg?821d44af";